<template>
    <div>
        <div class="d-flex align-items-end">
            <h4>Tipos de denuncia</h4>
            <div class="flex-grow-1"></div>
            <KarinTypeForm/>
        </div>
        <hr>
        <KarinListTypes/>
    </div>
</template>
<script>

import KarinTypeForm from './KarinSetting/Karin-type-form.vue'
import KarinListTypes from './KarinSetting/Karin-list-types.vue'
export default {
    name: 'KarinSetting',

    components: {
        KarinTypeForm,
        KarinListTypes,
    }
}
</script>

<style scoped>
h4 {
    margin-bottom: 0;
}
</style>